<template>
    <CommonDialog v-show="show" :title="message.title" class="merge-confirm" @close="handleClose">
        <template v-slot:msg>
            <span class="dialog-message">{{ userData.userName }}</span>
        </template>
        <template v-slot:buttons>
            <div class="button-slot button-group">
                <div v-if="isShowAccountChange" class="light-orange-btn btn-txt dialog-btn" @click="handleChangeAccount">{{ message.changeAccount }}</div>
                <div class="blue-btn btn-txt dialog-btn" @click="handleConfirm">{{ message.confirm }}</div>
            </div>
        </template>
    </CommonDialog>
</template>

<script>
import { useUserStore } from "../../../js/user_data";
import SaveTool from "../../../js/toolbar/save_tool";
import CommonDialog from "../Dialog.vue";
import AppRenderer from "../../../js/app_renderer";
import EventBus from "../../../js/event_bus";
import { VIEW_TYPE } from "../../../js/view_type";
import { store } from "../../../store";

export default {
    name: "MergeConfirm",
    data() {
        return {
            show: false,
            userData: useUserStore(),
            recordName: "",
            message: {
                title: "您即將把本次紀錄同步到此帳號",
                confirm: "確認",
                changeAccount: "換帳號",
            },
        };
    },
    components: {
        CommonDialog,
    },
    methods: {
        /**
         * show dialog for check merge
         * @param {String} name name of user's record
         */
        showDialog(name) {
            this.recordName = name;
            this.show = true;
        },
        /**
         * 確認同步身分
         */
        handleConfirm() {
            EventBus.getInstance().getAppRefs().messageDialog.showDialog("紀錄進度", "檢查重複檔名中...");
            AppRenderer.Instance.getRepeatRecordId(this.recordName);

            this.show = false;
        },
        /**
         * 取消登入身分，改其他身分進行上傳
         */
        handleChangeAccount() {
            this.show = false;
            // 登出之後再登入
            SaveTool._instance.logout();

            SaveTool._instance.handleLogin()();
        },
        handleClose() {
            this.show = false;
        },
    },
    computed: {
        isShowAccountChange() {
            if (store.nowView == VIEW_TYPE.ANDROID || store.nowView == VIEW_TYPE.IOS) {
                return false;
            } else {
                return true;
            }
        },
    },
};
</script>

<style src="../../../css/dialog_style.css" />
<style scoped>
.merge-confirm {
    z-index: 9999;
}

.button-slot {
    margin-bottom: 1rem;
}
</style>
